import React from 'react';
import style from './loading-view.module.scss';

export default function LoadingView() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div className={style.spinner} />
    </div>
  );
}
